<div class="main-grid flex-fill">
  <!-- TOOLBAR -->
  <div class="toolbar d-flex flex-nowrap align-items-stretch h-size-15 px-2 py-2">
    <!-- VIEW CHOOSER -->
    <app-button-group title="View" [(selectedValue)]="match.activeView">
      <button id="slateButton" buttonGroupItem="slate" title="Show Slate">
        <img [src]="match.logoUrl" class="w-100 h-100 image-fit p-2" alt="Show Slate">
      </button>
      <button buttonGroupItem="scoreboard" title="Scoreboard" class="p-2">
        <img [src]="scoreboardPreviewUrl" class="w-100 h-100 image-cover rounded" alt="Scoreboard">
      </button>
      @if (viewAvailable('guesses')) {
        <button buttonGroupItem="guesses" title="Guess">
          <img src="/assets/guess.png" class="w-100 h-100 image-fit p-2" alt="Guess">
        </button>
      }
      @if (viewAvailable('themes')) {
        <button buttonGroupItem="themes" title="Themes">
          <i class="bi-card-image"></i>
        </button>
      }
    </app-button-group>

    <div class="flex-fill"></div>

    <app-match-clock />
  </div>

  <app-score [editable]="true" />
  @switch (match.activeView) {
    @case ('themes') {
      <app-theme-slide-selector />
    }
    @default {
      <app-guess-selector />
    }
  }
  @if (match.round.enabled) {
    <app-rounds [editable]="true"/>
  }
</div>

<app-sidebar />
@if (!match.profileSelected) {
  <app-profile-picker />
}
